import React from 'react';
import { Flag, Mail, MapPin } from 'lucide-react';
import { PAYPAL_URL } from '../utils/donate';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-slate-950 pt-16 pb-8 border-t-4 border-pac-red text-slate-300" data-id="element-86" data-mp="32nulgo2wc31d">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87" data-mp="32m1cv38q38qq">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-88" data-mp="36pzblcu4yhj9">
          <div className="col-span-1 md:col-span-2" data-id="element-89" data-mp="3uesa9h2573hk">
            <div className="flex items-center gap-2 mb-6" data-id="element-90" data-mp="3ucxs2ai99ph6">
              <Flag className="h-8 w-8 text-pac-gold" data-id="element-91" data-mp="37o2ul235f8m" />
              <div className="flex flex-col" data-id="element-92" data-mp="3lec9ifcsaage">
                <span className="font-serif font-bold text-2xl leading-tight text-white tracking-wide uppercase" data-id="element-93" data-mp="3ldkf37uxairp">
                  AZ City PAC
                </span>
                <span className="text-xs font-sans font-semibold text-pac-gold tracking-[0.2em] uppercase" data-id="element-94" data-mp="29ynnprb9nhh6">
                  Arizona City Political Action Committee
                </span>
              </div>
            </div>
            <p className="text-slate-400 mb-6 max-w-md leading-relaxed" data-id="element-95" data-mp="3lalkbra34rzr">
              A statewide coalition protecting local decision-making and
              advancing policies that strengthen Arizona&apos;s cities and
              towns. Built locally. Stronger together.
            </p>
            <a href="/#join" className="inline-flex items-center gap-2 border-2 border-pac-gold text-pac-gold hover:bg-pac-gold hover:text-pac-navy px-5 py-2.5 rounded font-bold uppercase tracking-wider text-sm transition-colors" data-id="element-96" data-mp="3q7lo1vjgpinp">
              Join the Coalition
            </a>
          </div>

          <div data-id="element-97" data-mp="hs21tgh7l0i5">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-98" data-mp="huo4p2t5mru1">
              Quick Links
            </h2>
            <ul className="space-y-3" data-id="element-99" data-mp="qujlpo9e5h1z">
              <li data-id="element-100" data-mp="qrf9c3lrvf08">
                <a href="/#mission" className="hover:text-pac-gold transition-colors" data-id="element-101" data-mp="mrwpzc9lnbzi">
                  Our Mission
                </a>
              </li>
              <li data-id="element-102" data-mp="yty1bvsfwx5p">
                <a href="/#commitments" className="hover:text-pac-gold transition-colors" data-id="element-103" data-mp="yteimcuyu4qm">
                  Our Commitments
                </a>
              </li>
              <li data-id="element-104" data-mp="18l2c0jb31vuq">
                <a href="/#issues" className="hover:text-pac-gold transition-colors" data-id="element-105" data-mp="18lbulltst0qe">
                  Where Local Voices Matter
                </a>
              </li>
              <li data-id="element-106" data-mp="1hmidu2nu0pnc">
                <a href="/#join" className="hover:text-pac-gold transition-colors" data-id="element-107" data-mp="1mk1s32kj52fa">
                  Join the Coalition
                </a>
              </li>
              <li data-id="element-108" data-mp="3obok97g5r3dc">
                <a href="/#leadership" className="hover:text-pac-gold transition-colors" data-id="element-109" data-mp="3oc6rez4cz201">
                  Board of Directors
                </a>
              </li>
              <li data-id="element-110" data-mp="2agolrbdowefd">
                <Link to="/news" className="hover:text-pac-gold transition-colors" data-id="element-111" data-mp="2ah860yqtbewk">
                  News & Updates
                </Link>
              </li>
              <li data-id="element-112" data-mp="21kfqm8wqw1z1">
                <a href={PAYPAL_URL} target="_blank" rel="noopener noreferrer" className="text-pac-red font-bold hover:text-red-400 transition-colors" data-id="element-113" data-mp="1wo8rayyutoq2">
                  Contribute
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-114" data-mp="2kbqaw77ytghy">
            <h2 className="text-white font-serif font-bold text-lg mb-6 uppercase tracking-wider" data-id="element-115" data-mp="2kbgn8qae7lff">
              Contact
            </h2>
            <ul className="space-y-4" data-id="element-116" data-mp="18xutertl8vnk">
              <li className="flex items-start gap-3" data-id="element-117" data-mp="18yxprf9ojqav">
                <MapPin className="h-5 w-5 text-pac-gold shrink-0 mt-0.5" data-id="element-118" data-mp="13zb72qb31huo" />
                <span data-id="element-119" data-mp="141e9yaxc35gt">
                  Arizona City PAC
                  <br data-id="element-120" data-mp="2ruxya7cuxmu1" />
                  Arizona
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-121" data-mp="2wnhlzx59dyck">
                <Mail className="h-5 w-5 text-pac-gold shrink-0" data-id="element-122" data-mp="2iv1fgmd5fi6w" />
                <span data-id="element-123" data-mp="2iwm7a482wn12">info@azcitypac.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col items-center text-center" data-id="element-124" data-mp="2nue4ndrht1cn">
          <div className="border-2 border-slate-700 p-4 mb-6 max-w-3xl w-full" data-id="element-125" data-mp="3bki1n2a6e2uo">
            <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-126" data-mp="3fk0m5wy34bwz">
              Paid for by Arizona City Political Action Committee. Not
              authorized by any candidate or candidate&apos;s committee.
            </p>
          </div>
          <p className="text-xs text-slate-500 max-w-3xl mb-4" data-id="element-127" data-mp="1q5uihrtcf0nr">
            Contributions to Arizona City Political Action Committee are not
            deductible as charitable contributions for federal income tax
            purposes. Federal law requires us to use our best efforts to collect
            and report the name, mailing address, occupation, and name of
            employer of individuals whose contributions exceed $200 in a
            calendar year.
          </p>
          <p className="text-xs text-slate-600" data-id="element-128" data-mp="1rnjccengb5g8">
            &copy; {new Date().getFullYear()} Arizona City Political Action
            Committee. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}